import React from "react";

interface Props {
  content: string;
}

const SlideText = React.memo(({ content }: Props) => {
  return (
    <div className="m-3 p-5 bg-slate-200 border rounded shadow-md justify-center">
      <p className="text-left whitespace-pre-wrap">{content}</p>
    </div>
  );
});

export default SlideText;
